import React from 'react';
import { BeatLoader } from 'react-spinners';
import { LoadingContainer } from './styles';
import { theme } from 'src/Utils';
export var LoadingState = function () {
    return (React.createElement(LoadingContainer, null,
        React.createElement(BeatLoader, { size: "5px", color: theme.palette.black[100] })));
};
